<template>
  <div v-if="item && item.modelCode !== 'coverage'" :key="uuid" class="item-manager position-relative">
    <div class="d-flex flex-column justify-content-center align-items-center">
      <draggable>
        <div class="d-flex align-items-center">
          <div v-if="leftButton" class="d-flex align-items-center me-5" @click="moreChildren('left')">
            <div class="d-flex align-items-center cursor-pointer rounded-circle border border-dashed border-gray-400 btn btn-light-primary btn-circle btn-icon align-self-center">
              <i class="fad fa-angle-left fs-2x"></i>
            </div>
          </div>
          <div class="d-flex position-relative item-tree-container">
            <div :id="'item_' + item.uuid" :class="{'border-danger bg-light-danger': !item.isValid,'border-success bg-light-success':item.isValid}" :data-parent="parentItemUuid" class="position-relative draggable-item border-dashed rounded cursor-pointer p-2" style="aspect-ratio: 1 / 1"
                 @dblclick="editItem(item)">
              <div v-if="itemModel && itemModel.className === 'Asset'" class="position-absolute" style="top:-5px;right:-5px">
                <i v-if="item.isValid && itemCoverage" class="fas fa-shield-check fs-2 text-success"></i>
                <i v-else-if="item.properties && item.properties.packCategory" class="fas fa-shield-exclamation fs-2 text-warning"></i>
                <i v-else class="fas fa-shield-times fs-2 text-danger"></i>
              </div>
              <div v-if="!item.isValid" class="position-absolute" style="top:-5px;left:-5px">
                <i class="fas fa-exclamation-circle fs-2 text-danger"></i>
              </div>
              <div v-else class="position-absolute" style="top:-5px;left:-5px">
                <i class="fas fa-check-circle fs-2 text-success"></i>
              </div>
              <div v-if="itemPhoto" class="d-flex justify-content-center">
                <img :src="itemPhoto" alt="" class="rounded-circle object-cover" style="width:48px;height:48px"/>
              </div>
              <div v-else-if="itemModel && itemModel.icon">
                <i :class="itemModel.icon+' fs-3x'"></i>
              </div>
              <div class="fw-bolder mt-2 fs-8 px-2 text-uppercase text-center overflow-auto d-flex flex-column align-items-center justify-content-center cursor-pointer" style="max-lines: 2;line-clamp: 2;">
                <div>{{ itemAlias || itemIdentifier }}</div>
                <div v-if="itemAlias && itemIdentifier && itemAlias !== itemIdentifier" class="text-muted fw-normal fs-9" style="line-height:1">
                  {{ itemIdentifier }}
                </div>
              </div>
              <!--              <div class="fw-bolder mt-2 fs-8 px-2 text-uppercase text-center overflow-auto d-flex align-items-center justify-content-center cursor-pointer" style="max-lines: 2;line-clamp: 2;">-->
              <!--                {{ item.alias() }}-->
              <!--              </div>-->

              <div v-if="item.isValid && itemCoverage">
                <div class="fw-bolder fs-8 badge badge-success">
                  {{ itemCoverage.pack.label }}
                </div>
                <div class="fw-bolder text-success text-center my-1">
                  {{ currency(itemCoverage?.premium) }}
                </div>
              </div>
              <div v-if="hasObjectItem" class="border border-dashed border-dark position-absolute btn btn-circle btn-xs btn-icon btn-circle shadow-sm bg-white cursor-pointer bg-hover-danger text-hover-white" style="bottom:-15px"
                   @click="expand">
                <i v-if="isExpanded" class="fas fa-angle-down fs-2 text-danger"></i>
                <i v-else class="fas fa-angle-up fs-2 text-danger"></i>
              </div>
            </div>

            <div class="position-absolute delete-button" style="bottom:100%;z-index:2;left:50%;transform:translateX(-50%)">
              <div v-if="isRemovable" class="btn btn-icon btn-danger btn-xs my-1" title="Supprimer cet objet" @click="removeItem(item)">
                <i class="fad fa-trash"></i>
              </div>
            </div>
            <!--            <Transition name="slide-fade">-->
            <!--              <div :style="{ '&#45;&#45;i': 1 }" class="menu bg-white rounded  border border-dashed border-gray-400 px-1 position-absolute flex-grow-1 h-100 flex-column justify-content-start"-->
            <!--                   style="left:100%;margin-left:5px;z-index:2">-->
            <!--                <div @click="editItem(item)" class="btn btn-icon btn-xs my-1 btn-primary" title="Modifier les propriétés">-->
            <!--                  <i class="fad fa-edit text-inverse-primary"></i>-->
            <!--                </div>-->
            <!--                <div class="btn  btn-icon btn-danger btn-xs my-1" @click="removeItem(item)" title="Supprimer cet objet" v-if="isRemovable">-->
            <!--                  <i class="fad fa-trash"></i>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </Transition>-->
          </div>
          <div v-if="addButton" v-b-tooltip.hover :title="canAdd ? ('Ajouter ' + addItemTypeName) : ('Ajout de ' + addItemTypeName + ' non autorisé pour ce type d\'avenant')"
               :class="canAdd ? 'btn-light-primary cursor-pointer' : 'btn-secondary opacity-50 cursor-not-allowed'"
               class="ms-5 d-flex flex-column align-items-center justify-content-center border border-dashed border-gray-400 btn rounded p-2 align-self-center"
               style="min-width: 100px; aspect-ratio: 1/1;"
               @click="canAdd && createSubItem()">
            <div class="d-flex align-items-center">
              <i class="fas fa-plus fs-2x"></i>
              <i v-if="addItemTypeIcon" :class="addItemTypeIcon + ' fs-2x ms-1'"></i>
            </div>
            <div class="fw-bolder mt-5 fs-8 text-uppercase text-center">
              Ajouter<br>{{ addItemTypeName }}
            </div>
          </div>
          <div v-if="rightButton" class="d-flex align-items-center ms-5 flex-column" @click="moreChildren('right')">
            <div class="d-flex align-items-center cursor-pointer rounded-circle border border-dashed border-gray-400 btn btn-light-primary btn-circle btn-icon align-self-center">
              <i class="fad fa-angle-right fs-2x"></i>
            </div>
          </div>
        </div>
      </draggable>

      <template v-if="item && hasObjectItem && isExpanded">
        <div class="connector flex-grow-1 align-self-stretch d-flex justify-content-center position-relative">
          <svg :id="'connector_'+item.uuid" class="connectors flex-grow-1 h-100 w-100" style="position: absolute;top:0;left:0">
            <template v-for="(prop, index) in objectProps">
              <template v-if="!prop.isCoverage">
                <template v-for="(child,cIndex) in prop.children">
                  <path :id="'hidden_connect_'+ child" :ref="'link' + index" class="path link pointer" d=""/>
                  <path :id="'connect_'+ child" :ref="'link' + index" class="path link" d=""/>
                </template>
              </template>
              <template v-if="prop.isObjectGroup">
                <template>
                  <path :id="'hidden_connect_' + prop.code" :ref="'link' + prop.code" class="path link hidden" d=""/>
                  <path :id="'connect_' + prop.code" :ref="'link' + prop.code" class="path link" d=""/>
                </template>
              </template>
            </template>
          </svg>
          <div class="h-100px"></div>
        </div>
      </template>
    </div>
    <div v-if="item && isExpanded" class="d-flex justify-content-center px-5 item-children">


      <div class="d-flex justify-content-center bg-transparent align-items-start position-relative" style="margin-bottom:20px;gap:30px;">


        <!--        <template v-for="(prop , index) in item.properties">-->
        <!--          <template v-if="prop.model.type.code.match(/OBJECT/) && showSubProperty(prop)">-->

        <!--            <DynamicScroller direction="horizontal" :items="prop.children" :min-item-size="100" class="scroller">-->
        <!--              <template v-slot="{ item :child, index, active }">-->
        <!--                <DynamicScrollerItem :item="child" :active="active"  :data-index="index">-->
        <!--                                  <AvenantItemTree :key="'item_tree_'+child" :parentItemUuid="item.uuid" :propertyUuid="prop.uuid" :uuid="child" :maxDepth="2" :level="level+1" @link="linkChildren" @expand="toggleChildren" @errorUpdated="errorUpdated" @itemUpdated="update" @removeItem="removeChild"/>-->
        <!--                </DynamicScrollerItem>-->
        <!--              </template>-->
        <!--            </DynamicScroller>-->
        <!--          </template>-->
        <!--        </template>-->

        <template v-for="(prop , index) in objectProps">
          <template v-if="!prop.isCoverage">
            <template v-for="(child,cIndex) in getChildrenWindow(prop)">
              <AvenantItemTree :key="'item_tree_'+child"
                               :add-button="prop.isObjectGroup && (prop.max === null || prop.children.length < prop.max) && (cIndex === getChildrenWindow(prop).length - 1)"
                               :add-item-type-name="prop.subItemType?.name || ''"
                               :add-item-type-icon="prop.subItemType?.icon || ''"
                               :left-button="prop.isObjectGroup && (propOffsets[prop.code] || 0) > 0 && cIndex === 0"
                               :level="level+1" :maxDepth="2" :parentItemUuid="item.uuid" :propertyUuid="prop.code"
                               :right-button="prop.isObjectGroup && (propOffsets[prop.code] || 0) + childrenSize < prop.children.length && cIndex === getChildrenWindow(prop).length - 1"
                               :uuid="child" @createItem="createItemForProp(prop)" @errorUpdated="errorUpdated" @expand="toggleChildren"
                               @itemUpdated="update" @link="linkChildren" @moreChildren="showMoreChildrenForProp($event,prop)" @removeItem="removeChild"/>
            </template>

            <template v-if="prop.children.length === 0">
              <div v-b-tooltip.hover :title="showAddButtontoProperty(prop) ? ('Ajouter ' + (prop.subItemType?.name || '')) : ('Ajout de ' + (prop.subItemType?.name || '') + ' non autorisé pour ce type d\'avenant')"
                   :class="showAddButtontoProperty(prop) ? 'btn-light-primary cursor-pointer' : 'btn-secondary opacity-50 cursor-not-allowed'"
                   class="d-flex flex-column align-items-center justify-content-center border border-dashed border-gray-400 btn rounded p-2 align-self-center"
                   style="min-width: 100px; aspect-ratio: 1/1;"
                   @click="showAddButtontoProperty(prop) && createItemForProp(prop)">
                <div class="d-flex align-items-center">
                  <i class="fas fa-plus fs-2x"></i>
                  <i v-if="prop.subItemType?.icon" :class="prop.subItemType.icon + ' fs-2x ms-1'"></i>
                </div>
                <div class="fw-bolder mt-2 fs-8 text-uppercase text-center">
                  Ajouter<br>{{ prop.subItemType?.name || '' }}
                </div>
              </div>
            </template>
          </template>
          <template v-if="prop.isObjectGroup">
            <div class="position-absolute border-dashed border rounded" style="width:calc(100% + 40px);height:calc(100% + 40px);top:-20px;left:-20px;pointer-events: none">
              <div v-if="prop.children.length > childrenSize" class="badge badge-danger position-absolute" style="top:-10px;right:5px">
                {{ (propOffsets[prop.code] || 0) + 1 }}–{{ Math.min((propOffsets[prop.code] || 0) + childrenSize, prop.children.length) }}
                / {{ prop.children.length }} {{ prop.model.name }}
              </div>
            </div>
          </template>
        </template>
      </div>
    </div>
    <transition name="slide-left-back">
      <!--      <div v-if="$store.state.contractStore.editedItem === item.uuid" class="position-fixed top-0 left-0 w-100 h-100" style="z-index: 101">-->
      <!--        <div class="filter w-100 h-100" @click="$store.state.contractStore.editedItem=null"></div>-->
      <div v-if="$store.state.contractStore.editedItem === item.uuid" class="position-fixed bg-white shadow-lg top-0 h-100 overflow-auto  d-flex" style="right:0;z-index:101">
        <div class="d-flex flex-column h-100 p-5 w-800px">
          <div class="bg-white pb-5" style="position: sticky;top:0;z-index:2;border-bottom:1px whitesmoke solid">
            <div class="d-flex justify-content-between align-items-center">
              <h1 class="mb-0 text-uppercase text-primary">{{ trans("Modifier l'objet") }} {{ trans(item.name) }}</h1>
              <div>
              </div>
              <div class="btn btn-danger btn-xs ms-5 btn-icon" @click="$store.state.contractStore.editedItem=null">
                <i class="fad fa-times"></i>
              </div>
            </div>
            <div class="text-uppercase text-muted fw-bolder my-2 fs-2">
              {{ alias }}
            </div>
            <!--            <div class="row" v-if="!showPackSelector">-->
            <!--              <div class="col col-4">-->
            <!--                <label class="fw-bolder">Nom</label>-->
            <!--                <div class="position-relative">-->
            <!--                  <input type="text" v-model="item.name" class="form-control form-control-solid" placeholder="Nom">-->

            <!--                </div>-->
            <!--              </div>-->
            <!--            </div>-->
          </div>
          <div class="my-5">
            <div class="row mt-5">
              <template v-for="(pm, code) in editableProperties">
                <AvenantPropertyManager :key="item.uuid + '_' + code" :itemUuid="item.uuid" :propertyCode="pm.code" :type="pm.type" :class="pm.type && pm.type.code === 'PACK_CATEGORY' ? 'col col-12' : 'col col-4'" @propertyUpdated="update"/>
              </template>
            </div>
          </div>

          <!-- Bloc "Configuration des offres" (custom isPackApplier) désactivé.
               L'édition de packCategory + garanties se fait désormais via PropertyPackCategory.vue
               quand l'itemType déclare la propriété packCategory.
          <div v-if="itemModel && itemModel.isPackApplier" class="my-5">
            <div class="fw-bolder fs-4 mb-3">
              <i class="fad fa-layer-group me-2"></i>
              Configuration des offres
            </div>
            <div class="row">
              <div class="col col-6">
                <label class="fw-bolder fs-7 mb-2">Catégorie de pack</label>
                <select class="form-control form-select" :value="item.properties.packCategory || ''" @change="setPackCategory($event.target.value)">
                  <option value="">Séléctionnez une catégorie</option>
                  <option v-for="cat in branchCategories" :key="cat.id" :value="cat.slug.toUpperCase()">{{ cat.label }}</option>
                </select>
              </div>
            </div>
            <div v-if="item.properties.packCategory" class="mt-5">
              <label class="fw-bolder fs-7 mb-2">Garanties</label>
              <div class="border rounded p-3" style="max-height:300px;overflow:auto">
                <div v-for="guarantee in availableGuarantees" :key="'g_'+guarantee.id" class="d-flex align-items-center py-2 border-bottom">
                  <div class="flex-grow-1">
                    <i v-if="guarantee.icon" :class="guarantee.icon + ' me-2'"></i>
                    <span class="fw-bolder">{{ guarantee.label }}</span>
                  </div>
                  <div class="d-flex" style="gap:8px">
                    <label class="btn btn-sm" :class="isRequiredGuarantee(guarantee.id) ? 'btn-success' : 'btn-light-success'" @click="toggleGuarantee(guarantee.id, 'required')">
                      <i class="fad fa-shield-check me-1"></i>Obligatoire
                    </label>
                    <label class="btn btn-sm" :class="isOptionalGuarantee(guarantee.id) ? 'btn-warning' : 'btn-light-warning'" @click="toggleGuarantee(guarantee.id, 'optional')">
                      <i class="fad fa-shield-plus me-1"></i>Optionnelle
                    </label>
                  </div>
                </div>
              </div>
              <div class="mt-3 d-flex align-items-center" style="gap:10px">
                <div class="btn btn-primary btn-sm" @click="applyPackToChildren">
                  <i class="fad fa-arrow-down-to-bracket me-2"></i>
                  Appliquer aux {{ getChildAssetCount() }} véhicules
                </div>
                <div class="fs-7">
                  <span class="badge badge-light-success">{{ getCompatibleInsurersCount() }} assureur(s) compatible(s)</span>
                </div>
              </div>
              <div v-if="compatibleInsurers.length > 0" class="mt-2 d-flex flex-wrap" style="gap:4px">
                <span v-for="ins in compatibleInsurers" :key="ins.id" class="badge badge-light-primary fs-9">{{ ins.label }}</span>
              </div>
            </div>
          </div>
          -->


          <!-- Bloc Asset (configuration héritée) désactivé. Géré par PropertyPackCategory.vue
               quand l'itemType Asset déclare la propriété packCategory.
          <div v-if="itemModel && itemModel.className === 'Asset'" class="flex-grow-1">
            <div v-if="item.properties.packCategory" class="my-5">
              <div class="d-flex align-items-center mb-3">
                <div class="fw-bolder fs-5">
                  <i class="fad fa-shield-check me-2 text-info"></i>
                  {{ getPackCategoryLabel(item.properties.packCategory) }}
                </div>
                <span class="badge badge-light-info ms-2 fs-9">hérité</span>
              </div>
              <div class="row mb-3">
                <div class="col col-6">
                  <label class="fw-bolder fs-7 mb-2">Catégorie</label>
                  <select class="form-control form-select form-select-sm" :value="item.properties.packCategory || ''" @change="setPackCategory($event.target.value)">
                    <option value="">Séléctionnez une catégorie</option>
                    <option v-for="cat in branchCategories" :key="cat.id" :value="cat.slug.toUpperCase()">{{ cat.label }}</option>
                  </select>
                </div>
              </div>
              <div class="border rounded p-3" style="max-height:200px;overflow:auto">
                <div v-for="guarantee in availableGuarantees" :key="'ag_'+guarantee.id" class="d-flex align-items-center py-1">
                  <div class="flex-grow-1 fs-7">
                    <i v-if="guarantee.icon" :class="guarantee.icon + ' me-1'"></i>
                    {{ guarantee.label }}
                  </div>
                  <div class="d-flex" style="gap:4px">
                    <label class="btn btn-sm" :class="isRequiredGuarantee(guarantee.id) ? 'btn-success' : 'btn-light-success'" @click="toggleGuarantee(guarantee.id, 'required')">
                      <i class="fad fa-shield-check"></i>
                    </label>
                    <label class="btn btn-sm" :class="isOptionalGuarantee(guarantee.id) ? 'btn-warning' : 'btn-light-warning'" @click="toggleGuarantee(guarantee.id, 'optional')">
                      <i class="fad fa-shield-plus"></i>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="!item.properties.packCategory" class="my-5">
              <div class="row mb-3">
                <div class="col col-6">
                  <label class="fw-bolder fs-7 mb-2">Catégorie de pack</label>
                  <select class="form-control form-select form-select-sm" :value="''" @change="setPackCategory($event.target.value)">
                    <option value="">Séléctionnez une catégorie</option>
                    <option v-for="cat in branchCategories" :key="'ac_'+cat.id" :value="cat.slug.toUpperCase()">{{ cat.label }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          -->

          <!-- Bloc Asset en lecture seule : affiche la config de pack héritée
               quand l'asset n'a pas de propriété packCategory déclarée mais qu'une valeur lui a été appliquée -->
          <div v-if="itemModel && itemModel.className === 'Asset' && !hasPackCategoryDeclared && item.properties.packCategory" class="my-5 border rounded p-4 bg-light-info">
            <div class="d-flex align-items-center mb-3">
              <div class="fw-bolder fs-5">
                <i class="fad fa-shield-check me-2 text-info"></i>
                {{ getPackCategoryLabel(item.properties.packCategory) }}
              </div>
              <span class="badge badge-light-info ms-2 fs-9">hérité</span>
            </div>
            <div v-if="(item.properties.requiredGuarantees || []).length > 0 || (item.properties.optionalGuarantees || []).length > 0" class="border rounded p-3 bg-white" style="max-height:300px;overflow:auto">
              <div v-for="guarantee in availableGuarantees" :key="'ag_ro_' + guarantee.id" class="d-flex align-items-center py-1 fs-7">
                <div class="flex-grow-1">
                  <i v-if="guarantee.icon" :class="guarantee.icon + ' me-2'"></i>
                  {{ guarantee.label }}
                </div>
                <div class="d-flex" style="gap:6px">
                  <span v-if="(item.properties.requiredGuarantees || []).includes(guarantee.id)" class="badge badge-success">
                    <i class="fad fa-shield-check me-1"></i>Obligatoire
                  </span>
                  <span v-else-if="(item.properties.optionalGuarantees || []).includes(guarantee.id)" class="badge badge-warning">
                    <i class="fad fa-shield-plus me-1"></i>Optionnelle
                  </span>
                  <span v-else class="text-muted">—</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Section Accès : auto (beneficiary/manager) en lecture seule + additionalAccesses éditable -->
          <div class="my-5 border-top pt-5">
            <div class="d-flex align-items-center mb-3">
              <i class="fad fa-user-shield fs-3 me-2 text-primary"></i>
              <div class="fw-bolder fs-4">Accès selfcare</div>
            </div>

            <div v-if="autoAccessHints.length > 0" class="mb-4">
              <div class="text-muted fs-7 mb-2">Accès générés automatiquement à l'émission de l'avenant :</div>
              <div class="d-flex flex-wrap" style="gap:6px">
                <span v-for="(hint, i) in autoAccessHints" :key="'auto_'+i" class="badge badge-light-primary fs-8">
                  <i class="fad fa-link me-1"></i>
                  <span class="fw-bold">{{ hint.identifier }}</span>
                  <span class="text-muted ms-1">· {{ hint.source }}</span>
                  <span v-if="hint.target" class="text-muted ms-1">→ {{ hint.target }}</span>
                </span>
              </div>
            </div>

            <div>
              <div class="text-muted fs-7 mb-2">Accès supplémentaires (manuels) :</div>
              <div v-for="(acc, idx) in additionalAccesses" :key="'add_'+idx" class="d-flex align-items-center mb-2" style="gap:8px">
                <input type="text" class="form-control form-control-sm" placeholder="Email ou téléphone" v-model="acc.identifier" @input="syncAdditionalAccesses">
                <div class="btn btn-icon btn-xs btn-light-danger" @click="removeAdditionalAccess(idx)">
                  <i class="fad fa-times"></i>
                </div>
              </div>
              <div class="btn btn-light-primary btn-sm mt-2" @click="addAdditionalAccess">
                <i class="fad fa-plus me-2"></i>Ajouter un accès
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-end py-5" style="gap:20px">
            <div class="btn btn-primary" @click="save">
              <i class="fad fa-save"></i>
              Enregistrer
            </div>
          </div>
        </div>

        <div v-if="showComparisonDetails && hasRole('ROLE_MANAGER')" class="p-5 h-100 overflow-auto d-flex">
          <div>
            <div class="d-flex justify-content-between align-items-center  p-5">
              <h1 class="mb-0">{{ trans('Détails de la comparaison') }}</h1>
              <div class="btn btn-danger btn-xs ms-5 btn-icon" @click="showComparisonDetails = false">
                <i class="fad fa-times"></i>
              </div>
            </div>
            <div class="">
              <div v-for="insurer in comparisonResume" style="border-top:1px whitesmoke solid;border-bottom:1px whitesmoke solid">
                <input :id="'insurer-accordion-' + insurer.uuid" :name="'insurer-accordion-' + insurer.uuid" class="checkbox-accordion hidden" type="checkbox"/>
                <label :for="'insurer-accordion-' + insurer.uuid" class="fw-bolder py-2 px-5 w-100 cursor-pointer  bg-hover-light-primary d-flex justify-content-between">
              <span>
              <i class="fad fa-caret-right me-1"></i>
              <i class="fad fa-caret-down me-1"></i>
              {{ insurer.label }}
                </span>
                  <span>
                <i v-if="!insurer.active" class="fad fa-exclamation-triangle text-danger" title="Désactivé"></i>
              </span>
                </label>
                <div class="accordion">
                  <div v-for="(pack, pIndex) in insurer.packs" :key="'debug-pack-' + insurer.id + '-' + (pack.id || pIndex)">
                    <label :for="'pack-accordion-' + insurer.id + '-' + (pack.id || pIndex)" class="fw-bolder py-1 w-100 px-5 ps-10 cursor-pointer bg-hover-light-primary d-flex justify-content-between">
                  <span>
                    <i class="fad fa-caret-right me-1"></i>
                    {{ pack.label }}
                  </span>
                      <span>
                    {{ currency(pack.premium) }}
                    <i v-if="!pack.enable" class="fad fa-exclamation-triangle text-danger" title="Désactivé"></i>

                  </span>
                    </label>
                    <input :id="'pack-accordion-' + insurer.id + '-' + (pack.id || pIndex)" :name="'pack-accordion-' + insurer.id + '-' + (pack.id || pIndex)" class="checkbox-accordion"
                           type="checkbox"/>
                    <div class="accordion ps-15">
                      <table class="table m-0 table-stripped">
                        <template v-for="detail in pack.details">

                          <tr class="fw-bolder py-1 cursor-pointer bg-hover-light-primary" @click="debugDetails(detail)">
                            <td class="py-1 px-5">
                              {{ detail.name }}
                            </td>
                            <td class="text-end px-5" style="text-align: right;padding-left:100px">
                              {{ currency(detail.value) }}
                            </td>
                          </tr>
                        </template>
                      </table>

                    </div>

                  </div>
                </div>
              </div>
              <div>
                <!-- <img :src="uploadRoot + packDetails.pack.insurer.photo" :alt="packDetails.pack.insurer.label" class="mh-50px"> -->
              </div>
              <div class="my-5 fw-bolder">
                <!-- {{ packDetails.pack.insurer.label }} ▪️ {{ packDetails.pack.label }} -->
              </div>
              <div>
                <table class="table table-striped">
                  <tbody>
                  <!-- <tr v-for="detail in packDetails.details">
                <td class="p-2">
                    {{ detail.name }}
                </td>
                <td class="text-end p-2">
                    {{ helper.currencyFormat(detail.value) }}
                </td>
            </tr> -->
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div v-if="functionDetail" class="p-5">
            <div class="d-flex justify-content-between align-items-center  p-5">
              <h1 class="mb-0">{{ functionDetail.insurer }} 🔸 {{ functionDetail.name }}</h1>
              <div class="btn btn-danger btn-xs ms-5 btn-icon" @click="functionDetail = null">
                <i class="fad fa-times"></i>
              </div>
            </div>
            <template v-if="functionDetail.inlineDetails && functionDetail.inlineDetails.length >0">
              <div v-for="detail in functionDetail.inlineDetails" class="d-flex flex-wrap">
                <div v-for="place in detail" class="d-flex align-items-center my-5 flex-wrap">
                  <div v-if="place.operation" class="mx-2  badge badge-light-info">
                    {{ place.operation }}
                  </div>
                  <div class="d-flex flex-column justify-content-center align-items-center position-relative">
                    <div v-if="place.expression" class="badge badge-secondary">
                      {{ place.expression }}
                    </div>
                    <div v-if="place.sub" class="d-flex flex-wrap">
                      <div v-for="sub in place.sub" class="d-flex flex-column justify-content-center align-items-center">
                        <div class="d-flex justify-content-center">
                          <div v-if="sub.operation" class="mx-2 badge badge-light-info">
                            {{ sub.operation }}
                          </div>
                          <div class="expression-wrapper cursor-pointer">
                            <div :class="{'badge-light-success' : sub.value === 'Vrai', 'badge-light-danger' : sub.value ===  'Faux'}" :title="sub.value" class="badge expression1 w-100">
                              {{ sub.expression }}
                            </div>
                            <div v-if="sub.expression2" :class="{'badge-light-success' : sub.value === 'Vrai', 'badge-light-danger' : sub.value ===  'Faux'}" :title="sub.value" class="badge expression2 w-100">
                              {{ sub.expression2 }}
                            </div>
                          </div>
                        </div>
                        <!--                    <div v-if="sub.value" class="badge position-absolute" style="top:calc(100% + 5px)"-->
                        <!--                    :class="{'badge-light-success' : sub.value === 'Vrai', 'badge-light-danger' : sub.value ===  'Faux'}">-->
                        <!--                      {{ sub.value }}-->
                        <!--                    </div>-->
                        <!--                    <div v-else>-->
                        <!--                      not numeric-->
                        <!--                    </div>-->
                      </div>
                    </div>
                    <div v-if="isNumeric(place.value)" class="badge badge-light-success position-absolute" style="top:calc(100% + 5px)">
                      {{ currency(place.value, false, false) }}
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>

      </div>
      <!--      </div>-->
    </transition>
  </div>

</template>
<script lang="ts">
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import Item from "@/entity/Item";
import PropertyManager from "@/views/Income/Avenant/PropertyManager.vue";
import {helper} from "@/services/Helper";
import Insurer from '@/entity/Insurer';
import Pack from "@/entity/Pack";
import PackGuarantee from "@/entity/PackGuarantee";
import Popup from "@/entity/Popup";
import EngineMethod from "@/entity/EngineMethod";
import Guarantee from "@/entity/Guarantee";
import store from "@/store";
import Coverage from "@/entity/Coverage";
import Risk from "@/entity/Risk";
import ItemType from "@/entity/ItemType";
import {createItemFromType, getItemPropertyValue, getItemModel, validateItem, getAlias, getIdentifier} from "@/services/ItemFunction";
import AvenantObjectGroupManager from "@/views/Income/Avenant/Components/AvenantObjectGroupManager.vue";
import AvenantItemEditor from "@/views/Income/Avenant/Components/AvenantItemEditor.vue";
import AvenantPropertyManager from "@/views/Income/Avenant/Components/AvenantPropertyManager.vue";
import {api} from "@/services/Api";
import {auth} from "@/services/Auth";
import Swal from "sweetalert2";
import {engineService} from "@/services/calculator/EngineService";
import {Carousel3d, Slide} from 'vue-carousel-3d';
import VirtualScrollHorizontal from "@/components/VirtualScrollHorizontal.vue";

@Component({
  name: 'AvenantItemTree',

  components: {VirtualScrollHorizontal, AvenantPropertyManager, AvenantItemEditor, AvenantObjectGroupManager, PropertyManager, Carousel3d, Slide}
})

export default class AvenantItemTree extends Vue {

  @Prop() uuid!: string
  @Prop({default: false}) leftButton!: boolean
  @Prop({default: false}) rightButton!: boolean
  @Prop({default: false}) addButton!: boolean
  @Prop({default: ''}) addItemTypeName!: string
  @Prop({default: ''}) addItemTypeIcon!: string
  items = this.$store.state.comparatorStore.items
  @Prop({default: 1}) level!: number
  @Prop({default: ''}) insurerRestriction?: string
  @Prop({default: null}) propertyName?: string
  @Prop({default: null}) propertyUuid?: string
  @Prop({default: null}) parentItemUuid?: string
  uKey = helper.generateId()
  showChildren = true
  showPackSelector = false
  certificateRemaining = store.state.comparatorStore.autoCertificates
  uploadRoot = api.uploadRoot
  hasObjectItem = false
  showComparisonDetails = false
  alias = ''
  identifier = ''
  aliasUpdate: any = null
  calculationTimeout: any = null
  linking: any
  propertiesChecked = false
  isRemovable = false
  initialPack: Pack | null = null
  oldResults: any[] = []
  oldCoverages: Coverage[] = []
  coverages: Coverage[] = []
  debugResults: any[] = []
  calculUuid = null
  currentCoverage: any = null
  stopCalculation = false
  comparisonResume: any[] = []
  functionDetail: any = null as any
  optionals: any[] = []
  optionalMap: any = {}
  propOffsets: any = {}

  get item() {
    return this.$store.getters["contractStore/getEntity"]('items', this.uuid) || null
  }

  get itemCoverage(): any {
    if (!this.item) return null
    const couvertureUuids = this.item.properties?.couverture
    if (!Array.isArray(couvertureUuids) || couvertureUuids.length === 0) return null
    const covItem = this.$store.getters["contractStore/getEntity"]('items', couvertureUuids[0])
    if (!covItem || covItem.modelCode !== 'coverage') return null
    const props = covItem.properties || {}
    // Résoudre le pack et l'insurer depuis le store
    const packs = this.$store.state.contractStore.packs || []
    const pack = packs.find((p: any) => p.code?.toUpperCase() === props.pack?.toUpperCase())
    return {
      uuid: covItem.uuid,
      label: props.label || pack?.label || null,
      pack: pack || {code: props.pack, label: props.label},
      category: pack?.category || {slug: props.categorie},
      insurer: pack?.insurer || null,
      premium: props.premium || 0,
      risks: props.risques || [],
      details: props.details || [],
      canSubscribe: true,
    }
  }

  syncCoverageToStore(coverage: any) {
    if (!this.item || !coverage) return
    const covUuid = coverage.uuid || helper.generateId()
    const covItem: any = {
      uuid: covUuid,
      modelCode: 'coverage',
      name: 'Couverture ' + (this.item.name || ''),
      errors: [],
      isValid: true,
      coverage: null,
      properties: {
        label: coverage.label || coverage.pack?.label || null,
        pack: coverage.pack?.code?.toUpperCase() || null,
        categorie: coverage.category?.slug?.toUpperCase() || coverage.pack?.category?.slug?.toUpperCase() || null,
        risques: coverage.risks ? coverage.risks.map((r: any) => ({
          guarantee: r.guarantee?.id,
          label: r.label,
          premium: r.premium,
          min: r.minDescription,
          max: r.maxDescription,
        })) : null,
        premium: coverage.premium || 0,
        details: coverage.details || [],
      }
    }
    store.commit('contractStore/addEntity', {type: 'items', item: covItem})
    Vue.set(this.item.properties, 'couverture', [covUuid])
    return covUuid
  }

  get isExpanded() {
    return this.$store.state.contractStore.itemsExpanded.includes(this.uuid)
  }

  get isObjectValid() {

    return true
  }

  isNumeric(value: any): boolean {
    return !isNaN(parseFloat(value)) && isFinite(value);
  }

  get branchCategories(): any[] {
    const branch = this.$store.state.contractStore.branch
    const all = this.$store.state.contractStore.packCategories
    const arr = Array.isArray(all) ? all : Object.values(all || {})
    if (!branch?.packCategories || !Array.isArray(branch.packCategories) || branch.packCategories.length === 0) return arr
    const branchCatIds = branch.packCategories.map((id: any) => Number(id))
    return arr.filter((c: any) => branchCatIds.includes(Number(c.id)))
  }

  get availableGuarantees(): any[] {
    const all = this.$store.state.contractStore.guarantees
    return Array.isArray(all) ? all : Object.values(all || {})
  }

  isRequiredGuarantee(id: number): boolean {
    return (this.item.properties.requiredGuarantees || []).includes(id)
  }

  isOptionalGuarantee(id: number): boolean {
    return (this.item.properties.optionalGuarantees || []).includes(id)
  }

  toggleGuarantee(id: number, type: 'required' | 'optional') {
    if (!this.item.properties.requiredGuarantees) Vue.set(this.item.properties, 'requiredGuarantees', [])
    if (!this.item.properties.optionalGuarantees) Vue.set(this.item.properties, 'optionalGuarantees', [])
    const req = this.item.properties.requiredGuarantees as number[]
    const opt = this.item.properties.optionalGuarantees as number[]
    if (type === 'required') {
      const idx = req.indexOf(id)
      if (idx !== -1) { req.splice(idx, 1) } else { req.push(id); const oi = opt.indexOf(id); if (oi !== -1) opt.splice(oi, 1) }
    } else {
      const idx = opt.indexOf(id)
      if (idx !== -1) { opt.splice(idx, 1) } else { opt.push(id); const ri = req.indexOf(id); if (ri !== -1) req.splice(ri, 1) }
    }
  }

  setPackCategory(slug: string) {
    Vue.set(this.item.properties, 'packCategory', slug || null)
    if (!slug) {
      Vue.set(this.item.properties, 'requiredGuarantees', [])
      Vue.set(this.item.properties, 'optionalGuarantees', [])
      return
    }
    // Pré-sélectionner les garanties non-optionnelles communes à tous les packs de cette catégorie
    const packs = (this.$store.state.contractStore.packs || []).filter(
      (p: any) => p.category?.slug?.toUpperCase() === slug.toUpperCase()
    )
    if (packs.length === 0) return
    // Pour chaque pack, collecter les IDs des garanties non-optionnelles
    const mandatoryPerPack = packs.map((p: any) =>
      (p.packGuarantees || []).filter((pg: any) => !pg.isOptional).map((pg: any) => pg.guarantee?.id)
    )
    // Garder uniquement celles présentes dans TOUS les packs
    const commonMandatory = mandatoryPerPack[0].filter((id: number) =>
      mandatoryPerPack.every((ids: number[]) => ids.includes(id))
    )
    Vue.set(this.item.properties, 'requiredGuarantees', commonMandatory)
    Vue.set(this.item.properties, 'optionalGuarantees', [])
  }

  getPackCategoryLabel(slug: string): string {
    const cat = this.branchCategories.find((c: any) => c.slug?.toUpperCase() === slug?.toUpperCase())
    return cat?.label || slug
  }

  getChildAssetCount(): number {
    let count = 0
    const walk = (parentUuid: string) => {
      const parent = this.$store.getters["contractStore/getEntity"]('items', parentUuid)
      if (!parent) return
      const model = getItemModel(parent)
      if (!model?.properties) return
      Object.values(model.properties).forEach((pm: any) => {
        const fmt = pm.type?.format || pm.type?.code || ''
        if (!fmt.match(/OBJECT/)) return
        const val = parent.properties?.[pm.code]
        const children = Array.isArray(val) ? val : (val ? [val] : [])
        children.forEach((uuid: string) => {
          const child = this.$store.getters["contractStore/getEntity"]('items', uuid)
          if (!child) return
          const childModel = getItemModel(child)
          if (childModel?.className === 'Asset') count++
          walk(uuid)
        })
      })
    }
    walk(this.item.uuid)
    return count
  }

  get compatibleInsurers(): any[] {
    const category = this.item.properties?.packCategory
    if (!category) return []
    const reqGuarantees: number[] = this.item.properties?.requiredGuarantees || []
    const insurerMap = this.$store.state.contractStore.insurers || {}
    const packs = this.$store.state.contractStore.packs || []
    return (Object.values(insurerMap) as any[]).filter((ins: any) => {
      if (!ins.packs || ins.packs.length === 0) return false
      // Trouver le pack de cet assureur dans la catégorie
      const pack = packs.find((p: any) =>
        (p.insurer?.slug === ins.slug || p.insurer?.id === ins.id) &&
        p.category?.slug?.toUpperCase() === category?.toUpperCase()
      )
      if (!pack) return false
      // Vérifier que toutes les garanties obligatoires demandées sont couvertes par le pack
      if (reqGuarantees.length === 0) return true
      const packGuaranteeIds = (pack.packGuarantees || []).map((pg: any) => pg.guarantee?.id)
      return reqGuarantees.every((gId: number) => packGuaranteeIds.includes(gId))
    })
  }

  getCompatibleInsurersCount(): number {
    return this.compatibleInsurers.length
  }

  applyPackToChildren() {
    const category = this.item.properties.packCategory
    const reqG = this.item.properties.requiredGuarantees || []
    const optG = this.item.properties.optionalGuarantees || []
    const uuids: string[] = []
    const walk = (parentUuid: string) => {
      const parent = this.$store.getters["contractStore/getEntity"]('items', parentUuid)
      if (!parent) return
      const model = getItemModel(parent)
      if (!model?.properties) return
      Object.values(model.properties).forEach((pm: any) => {
        const fmt = pm.type?.format || pm.type?.code || ''
        if (!fmt.match(/OBJECT/)) return
        const val = parent.properties?.[pm.code]
        const children = Array.isArray(val) ? val : (val ? [val] : [])
        children.forEach((uuid: string) => {
          const child = this.$store.getters["contractStore/getEntity"]('items', uuid)
          if (!child) return
          const childModel = getItemModel(child)
          if (childModel?.className === 'Asset') {
            Vue.set(child.properties, 'packCategory', category)
            Vue.set(child.properties, 'requiredGuarantees', [...reqG])
            Vue.set(child.properties, 'optionalGuarantees', [...optG])
            uuids.push(uuid)
          }
          walk(uuid)
        })
      })
    }
    walk(this.item.uuid)
    if (uuids.length > 0) {
      this.update(uuids)
    }
  }

  moreChildren(direction: string) {
    this.$emit('moreChildren', direction)
  }

  get canAdd() {
    const avenantType = this.$store.state.contractStore.avenantType
    if (!avenantType) return true
    return avenantType.allowAdd !== false
  }

  get itemIdentifier() {
    return getIdentifier(this.item)
  }

  get itemAlias() {
    return this.item ? getAlias(this.item) : ''
  }

  get itemPhoto(): string | null {
    const model = this.itemModel
    if (!model?.properties || !this.item?.properties) return null
    const props = Array.isArray(model.properties) ? model.properties : Object.values(model.properties)
    const photoProp: any = props.find((p: any) => {
      const code = p.type?.code || ''
      const format = p.type?.format || ''
      return code === 'PHOTO' || code === 'IMAGE' || format === 'PHOTO' || format === 'IMAGE' || p.link === 'photo'
    })
    if (!photoProp) return null
    const value = this.item.properties[photoProp.code]
    const path = Array.isArray(value) ? value[0] : value
    if (helper.empty(path)) return null
    if (typeof path === 'string' && path.match(/^(https?:)?\/\//)) return path
    return this.uploadRoot + path
  }

  get itemModel() {
    return getItemModel(this.item)
  }

  get hasPackCategoryDeclared(): boolean {
    const model = this.itemModel
    if (!model?.properties) return false
    const props = Array.isArray(model.properties) ? model.properties : Object.values(model.properties)
    return props.some((p: any) => p.code === 'packCategory')
  }

  getItemModel(item: any) {
    return getItemModel(item)
  }

  // Retourne les propriétés non-OBJECT éditables du modèle (pour le panneau latéral)
  get editableProperties(): any[] {
    const model = this.itemModel
    if (!model?.properties) return []
    return Object.values(model.properties).filter((pm: any) => {
      const format = pm.type?.format || pm.type?.code || ''
      return !format.match(/OBJECT/) && !pm.internal
    })
  }

  get childrenSize(): number {
    return this.$store.state.contractStore.childrenSize || 3
  }

  // Retourne les propriétés OBJECT/OBJECT_GROUP du modèle avec les children de l'item
  get objectProps(): any[] {
    const model = this.itemModel
    if (!model?.properties) return []
    const itemTypes = this.$store.state.contractStore.itemTypes
    return Object.values(model.properties).filter((pm: any) => {
      return pm.type?.format === 'OBJECT' || pm.type?.format === 'OBJECT_GROUP' || pm.type?.code?.match(/OBJECT/)
    }).map((pm: any) => {
      const value = this.item?.properties?.[pm.code]
      const children = Array.isArray(value) ? value : (value ? [value] : [])
      const subItemType: any = Object.values(itemTypes).find((it: any) => it.uuid === pm.value)
      return {
        code: pm.code,
        name: pm.name,
        model: pm,
        type: pm.type,
        children,
        min: pm.min,
        max: pm.max,
        subItemType,
        isCoverage: subItemType?.code === 'coverage',
        isObjectGroup: pm.type?.code === 'OBJECT_GROUP' || pm.type?.format === 'OBJECT_GROUP'
      }
    })
  }

  getChildrenWindow(prop: any) {
    const offset = this.propOffsets[prop.code] || 0
    return prop.children.slice(offset, offset + this.childrenSize)
  }

  showAddButtontoProperty(prop: any) {
    const avenantType = this.$store.state.contractStore.avenantType
    if (!avenantType) return true
    if (!avenantType.allowAdd) return false
    const subItemType = prop.subItemType || prop.subItemType?.()
    if (avenantType.allowedAddition?.length > 0 && subItemType) {
      return avenantType.allowedAddition.includes(subItemType.code)
    }
    return true
  }

  createSubItem(property: any) {
    this.$emit('createItem', property)
  }

  createItem(property: any) {
    const item = this.createPropertySubItem(property, false)
    Vue.set(this.propOffsets, property.code, Math.max(0, property.children.length - this.childrenSize))
    store.state.contractStore.editedItem = item.uuid
  }

  showMoreChildren(data: any, property: any) {
    if (data === 'right' && property.childrenPage < Math.ceil(property.children.length / this.$store.state.contractStore.childrenSize)) {
      property.childrenPage += 1
    } else if (data === 'left' && property.childrenPage > 1) {
      property.childrenPage -= 1
    }
  }

  createItemForProp(prop: any) {
    if (!prop.subItemType) return
    // Garde-fou défensif : respecter allowAdd / allowedAddition du type d'avenant
    // (la visibilité du bouton est déjà gated dans le template, mais cette fonction peut être appelée d'ailleurs)
    const avenantType = this.$store.state.contractStore.avenantType
    if (avenantType && !avenantType.allowAdd) return
    if (avenantType?.allowedAddition?.length > 0 && !avenantType.allowedAddition.includes(prop.subItemType.code)) return
    const newItem: any = {
      uuid: helper.generateId(),
      modelCode: prop.subItemType.code,
      name: prop.subItemType.name + ' N°' + (prop.children.length + 1),
      properties: {},
      errors: [],
      isValid: false,
      coverage: null,
    }
    // Initialiser les propriétés avec les valeurs par défaut du modèle
    Object.values(prop.subItemType.properties || {}).forEach((pm: any) => {
      const isObj = pm.type?.format === 'OBJECT' || pm.type?.format === 'OBJECT_GROUP'
      newItem.properties[pm.code] = isObj ? [] : (pm.value ?? null)
    })
    // Si un ancêtre est verrouillé (packLocked=true) ET a une propriété PACK_CATEGORY avec valeur, hériter
    // Lookup dynamique du code de propriété PACK_CATEGORY (peut être nommée différemment : 'packCategory', 'categorie_d_offre', etc.)
    const findPackCategoryCode = (modelCode: string): string | null => {
      const itemType = store.state.contractStore.itemTypes?.[modelCode]
      if (!itemType?.properties) return null
      const props = Array.isArray(itemType.properties) ? itemType.properties : Object.values(itemType.properties)
      const pm: any = props.find((p: any) => p.type?.code === 'PACK_CATEGORY' || p.code === 'packCategory')
      return pm?.code || null
    }
    let ancestorUuid = this.item.uuid
    while (ancestorUuid) {
      const ancestor = store.getters["contractStore/getEntity"]('items', ancestorUuid)
      if (!ancestor) break
      const ancestorPackCode = findPackCategoryCode(ancestor.modelCode)
      const ancestorCategory = ancestorPackCode ? ancestor.properties?.[ancestorPackCode] : null
      if (ancestor.properties?.packLocked === true && ancestorCategory) {
        // Hériter en utilisant le code propriété du nouvel item (peut être différent de celui de l'ancêtre)
        const newPackCode = findPackCategoryCode(newItem.modelCode) || 'packCategory'
        newItem.properties[newPackCode] = ancestorCategory
        newItem.properties.requiredGuarantees = [...(ancestor.properties.requiredGuarantees || [])]
        newItem.properties.optionalGuarantees = [...(ancestor.properties.optionalGuarantees || [])]
        break
      }
      ancestorUuid = ancestor.parentItem
    }
    store.commit('contractStore/addEntity', {type: 'items', item: newItem})
    // Ajouter l'uuid dans les children de la propriété parente
    const children = this.item.properties[prop.code]
    if (Array.isArray(children)) {
      children.push(newItem.uuid)
    } else {
      Vue.set(this.item.properties, prop.code, [newItem.uuid])
    }
    this.$emit('link')
    // Notifier que l'item courant a été modifié (ajout d'un descendant) pour que
    // AvenantGenerator puisse invalider/rafraîchir la comparaison
    this.update([this.item.uuid])
    return newItem
  }

  showMoreChildrenForProp(data: any, prop: any) {
    const offset = this.propOffsets[prop.code] || 0
    const max = prop.children.length - this.childrenSize
    if (data === 'right' && offset < max) {
      Vue.set(this.propOffsets, prop.code, offset + 1)
    } else if (data === 'left' && offset > 0) {
      Vue.set(this.propOffsets, prop.code, offset - 1)
    }
  }

  shouldUpdateName() {
    clearTimeout(this.aliasUpdate)
    this.aliasUpdate = setTimeout(() => {
      clearTimeout(this.aliasUpdate)
      this.updateName()
    }, 20)
  }

  // checkAllPropertiesMin() {
  //   if (this.propertiesChecked) {
  //     return
  //   }
  //   this.item.properties.forEach((p: any) => {
  //     this.checkPropertyMin(p)
  //   })
  // }

  updateName() {
    this.alias = this.item ? getAlias(this.item) : ''
    this.identifier = this.item ? getIdentifier(this.item) : ''
  }

  save() {
    this.syncAdditionalAccesses()
    this.$store.state.contractStore.editedItem = null
    // this.calculatePremium()
  }

  get additionalAccesses(): any[] {
    if (!this.item) return []
    const params = this.item.params || []
    if (Array.isArray(params)) {
      const entry = params.find((p: any) => p && p.code === 'additionalAccesses')
      return entry && Array.isArray(entry.value) ? entry.value : []
    }
    return Array.isArray(params.additionalAccesses) ? params.additionalAccesses : []
  }

  addAdditionalAccess() {
    if (!this.item) return
    const list = [...this.additionalAccesses, {identifier: ''}]
    this.writeAdditionalAccesses(list)
  }

  removeAdditionalAccess(idx: number) {
    const list = [...this.additionalAccesses]
    list.splice(idx, 1)
    this.writeAdditionalAccesses(list)
  }

  syncAdditionalAccesses() {
    const cleaned = this.additionalAccesses
        .map((a: any) => ({identifier: (a.identifier || '').trim()}))
        .filter((a: any) => a.identifier !== '')
    this.writeAdditionalAccesses(cleaned)
  }

  private writeAdditionalAccesses(list: any[]) {
    if (!this.item) return
    if (!Array.isArray(this.item.params)) {
      this.$set(this.item, 'params', [])
    }
    const params: any[] = this.item.params
    const index = params.findIndex((p: any) => p && p.code === 'additionalAccesses')
    if (index !== -1) {
      if (list.length === 0) {
        params.splice(index, 1)
      } else {
        this.$set(params, index, {code: 'additionalAccesses', value: list})
      }
    } else if (list.length > 0) {
      params.push({code: 'additionalAccesses', value: list})
    }
  }

  get autoAccessHints(): Array<{identifier: string; source: string; target?: string}> {
    const hints: Array<{identifier: string; source: string; target?: string}> = []
    if (!this.item || !this.itemModel) return hints
    const items: any = this.$store.state.contractStore.items
    const itemTypes: any = this.$store.state.contractStore.itemTypes

    // 1) En tant que CIBLE — bénéficiaire : si je suis un Asset, je cherche le Customer lié via mes propriétés objets,
    //    ou via un Customer dont une propriété pointe vers moi (même logique que AvenantGenerator.placeOrder)
    if (this.itemModel.className === 'Asset') {
      let ben: any = null
      if ((this.item as any).beneficiary?.uuid) {
        ben = items[(this.item as any).beneficiary.uuid] || null
      }
      if (!ben && this.item.properties) {
        for (const propValue of Object.values(this.item.properties) as any[]) {
          if (!Array.isArray(propValue)) continue
          for (const childUuid of propValue) {
            const child = items[childUuid]
            const childModel = child ? itemTypes[child.modelCode] : null
            if (childModel?.className === 'Customer') { ben = child; break }
          }
          if (ben) break
        }
      }
      if (!ben) {
        for (const other of Object.values(items) as any[]) {
          const otherModel = itemTypes[other?.modelCode]
          if (otherModel?.className !== 'Customer' || !other.properties) continue
          for (const propValue of Object.values(other.properties) as any[]) {
            if (Array.isArray(propValue) && propValue.includes(this.item.uuid)) { ben = other; break }
          }
          if (ben) break
        }
      }
      if (ben) {
        const id = getIdentifier(ben)
        if (id) hints.push({identifier: id, source: 'bénéficiaire'})
      }
    }

    // 2) En tant que CIBLE — gestionnaire : tout Customer dans le contrat avec grantsAccessTo === mon code
    //    dont l'ancêtre le plus proche matchant ce code est moi.
    //    Parent résolu par parentUuid si dispo, sinon en cherchant qui contient cet item dans ses propriétés objets.
    const findParent = (childUuid: string): any => {
      const child = items[childUuid]
      if (child?.parentUuid && items[child.parentUuid]) return items[child.parentUuid]
      for (const other of Object.values(items) as any[]) {
        if (!other?.properties) continue
        for (const propValue of Object.values(other.properties) as any[]) {
          if (Array.isArray(propValue) && propValue.includes(childUuid)) return other
        }
      }
      return null
    }
    for (const other of Object.values(items) as any[]) {
      const otherModel = itemTypes[other.modelCode]
      if (otherModel?.className !== 'Customer' || !otherModel?.grantsAccessTo) continue
      if (otherModel.grantsAccessTo !== this.itemModel.code) continue
      let current: any = other
      const visited = new Set<string>()
      while (current && !visited.has(current.uuid)) {
        visited.add(current.uuid)
        const parent = findParent(current.uuid)
        if (!parent) break
        const parentModel = itemTypes[parent.modelCode]
        if (parentModel?.code === this.itemModel.code) {
          if (parent.uuid === this.item.uuid) {
            const id = getIdentifier(other)
            if (id) hints.push({identifier: id, source: 'gestionnaire'})
          }
          break
        }
        current = parent
      }
    }

    // 3) En tant que SOURCE — si je suis un Customer avec grantsAccessTo, mon identifier accède à l'ancêtre matchant
    if (this.itemModel.className === 'Customer' && this.itemModel.grantsAccessTo) {
      const id = getIdentifier(this.item)
      if (id) {
        hints.push({identifier: id, source: 'manager', target: this.itemModel.grantsAccessTo})
      }
    }

    // 4) En tant que SOURCE — si je suis un Customer bénéficiaire d'Assets, mon identifier accède à chacun
    if (this.itemModel.className === 'Customer') {
      const myId = getIdentifier(this.item)
      if (myId) {
        const assetTargets = new Set<string>()
        if (this.item.properties) {
          for (const propValue of Object.values(this.item.properties) as any[]) {
            if (!Array.isArray(propValue)) continue
            for (const childUuid of propValue) {
              const child = items[childUuid]
              const childModel = child ? itemTypes[child.modelCode] : null
              if (childModel?.className === 'Asset') assetTargets.add(child.uuid)
            }
          }
        }
        for (const other of Object.values(items) as any[]) {
          const otherModel = itemTypes[other?.modelCode]
          if (otherModel?.className !== 'Asset' || !other.properties) continue
          for (const propValue of Object.values(other.properties) as any[]) {
            if (Array.isArray(propValue) && propValue.includes(this.item.uuid)) {
              assetTargets.add(other.uuid)
              break
            }
          }
        }
        for (const assetUuid of assetTargets) {
          const asset = items[assetUuid]
          const assetModel = asset ? itemTypes[asset.modelCode] : null
          const label = assetModel?.name || assetModel?.code || asset?.defaultAlias || asset?.generatedAlias || assetUuid
          hints.push({identifier: myId, source: 'bénéficiaire', target: label})
        }
      }
    }
    return hints
  }

  update(uuids: any) {
    if (!Array.isArray(uuids)) {
      uuids = []
    }
    if (!uuids.includes(this.item.uuid)) {
      uuids.push(this.item.uuid)
    }

    this.shouldUpdateName()
    this.checkHasItemChild()
    this.$emit('itemUpdated', uuids)

  }

  preparePremiumCalculation() {
    clearTimeout(this.calculationTimeout)
    this.calculationTimeout = setTimeout(() => {
      clearTimeout(this.calculationTimeout)
      this.calculatePremium()
    }, 200)
  }

  @Watch('item.calculationKey')
  requirementUpdate() {
    if (this.item && this.item.calculationKey !== null) {
      this.preparePremiumCalculation()
    }
  }

  createPropertySubItem(property: any, expand = true, autoCreate = false) {

    const avenantType = this.$store.state.contractStore.avenantType
    const it = property.subItemType()
    if (!autoCreate) {
      if (avenantType && !avenantType.allowAdd) {
        new Popup('Non autorisé', "Ce type d'avenant n'autorise pas l'ajout d'objets")
        return
      }
      if (avenantType?.allowedAddition?.length > 0 && !avenantType.allowedAddition.includes(it.code)) {
        new Popup('Non autorisé', "Ce type d'avenant n'autorise pas l'ajout de " + it.name)
        return
      }
    }
    // Garde-fou cardinalite : respecter le max defini sur la propriete (ex. 5 enfants).
    // Convention : max = 0 (ou null) signifie illimite.
    const max = Number(property?.model?.max)
    if (!isNaN(max) && max > 0 && property.children.length >= max) {
      if (!autoCreate) {
        new Popup('Maximum atteint', "Limite de " + max + " " + it.name + " atteinte")
      }
      return
    }
    const item = createItemFromType(it)
    item.name = getItemModel(item).name + ' N°' + (property.children.length + 1)
    item.parentItem = this.item.uuid
    item.parentPropertyCode = property.code || property.model?.code

    property.children.push(item.uuid)
    store.commit('contractStore/addEntity', {type: 'items', item: item});
    if (expand) {
      // this.toggleChildren([item.uuid, this.item.uuid])
      // this.$store.commit('contractStore/addItemExpanded', item.uuid)
      // this.$store.state.contractStore.itemsExpanded.push(item.uuid)
    }
    this.$emit('link')
    return item
  }

  checkHasItemChild() {
    this.hasObjectItem = this.objectProps.some(p => !p.isCoverage)
  }

  expand() {

    if (this.isExpanded) {
      this.toggleChildren(null)
    } else {
      this.toggleChildren([this.uuid])

    }
  }

  prepareChildrenLink() {
    clearTimeout(this.linking)
    this.linking = setTimeout(this.linkChildren, 100)
  }

  showSubProperty(prop: any) {
    if (prop.model.type.code.match(/OBJECT/)) {
      // this.checkPropertyMin(prop)
      this.prepareChildrenLink()
      if (prop.subItemType().code === 'coverage') {
        return false
      }
      this.hasObjectItem = true
      return true

    }
  }

  checkPropertyMin(prop: any) {
    if (!this.showAddButtontoProperty(prop)) return
    let min = 0
    if (!prop.isObjectGroup) {
      min = 1
    } else if (prop.min > 0) {
      min = prop.min
    }
    const missing = min - prop.children.length
    if (missing > 0) {
      for (let i = 0; i < missing; i++) {
        this.createItemForProp(prop)
      }
    }
    if (prop.children.length > 0) {
      this.toggleChildren([prop.children[0], this.item.uuid])
    }
  }

  toggleChildren(evt: any) {
    this.showChildren = !this.showChildren
    if (!Array.isArray(evt)) {
      evt = []
    } else {
      evt.push(this.item.uuid)

    }
    this.$emit('expand', evt)
    this.$emit('link')
  }

  checkRemovable() {
    const avenantType = this.$store.state.contractStore.avenantType
    if (getItemModel(this.item).isRoot || getItemModel(this.item).required) {
      return false
    }
    if (avenantType && !avenantType.allowRemove) {
      return false
    }
    if (avenantType?.allowedRemove?.length > 0 && !avenantType.allowedRemove.includes(getItemModel(this.item)?.code)) {
      return false
    }
    if (this.parentItemUuid && this.propertyUuid) {
      const parentItem = this.$store.getters["contractStore/getEntity"]('items', this.parentItemUuid)
      if (parentItem) {
        const parentModel = this.$store.state.contractStore.itemTypes[parentItem.modelCode]
        if (parentModel?.properties) {
          const pm: any = (Array.isArray(parentModel.properties) ? parentModel.properties : Object.values(parentModel.properties))
            .find((p: any) => p.code === this.propertyUuid)
          if (pm?.type?.code === 'OBJECT') {
            return false
          }
        }
      }
    }
    return true
  }

  linkChildren() {
    this.$emit('link')
  }

  getItemTypeByUuid(uuid: string) {
    return this.$store.state.comparatorStore.itemTypes.find((it: ItemType) => {
      return it.uuid === uuid
    })
  }

  toggleAsaciRequest(event: any) {
    const index = this.item.params.findIndex((param: any) => {
      return param.code === 'blockAsaciRequest'
    })
    if (index !== -1) {
      this.item.params.splice(index, 1)
    }
    if (!event.target.checked) {
      this.item.params.push({code: 'blockAsaciRequest', value: true})
    }
  }

  editItem(item: any) {
    store.state.contractStore.editedItem = this.item.uuid
    this.showPackSelector = false
  }

  @Watch("item.errors")
  errorUpdated(errors: any) {
    if (this.item && helper.empty(this.item.errors) && !helper.empty(errors)) {
      this.item.errors = errors
      this.item.isValid = false
    }
    this.$emit('errorUpdated', errors)
  }

  async mounted() {
    this.$addListener(window, 'resize', this.linkChildren);

    this.$emit('link')
    if (!this.item) return
    // Vue.set pour garantir la réactivité — sans ça, getAlias (qui dépend de parentItem)
    // ne se re-calcule pas et l'alias reste cached sur la valeur initiale "Santé N°1"
    Vue.set(this.item, 'parentItem', this.parentItemUuid)
    // propertyUuid est en réalité le code de la property, résoudre le vrai UUID
    if (this.parentItemUuid && this.propertyUuid) {
      const parentItem = this.$store.getters["contractStore/getEntity"]('items', this.parentItemUuid)
      if (parentItem) {
        const parentModel = this.$store.state.contractStore.itemTypes[parentItem.modelCode]
        const propModel: any = parentModel?.properties?.[this.propertyUuid]
        Vue.set(this.item, 'parentProperty', propModel?.uuid || this.propertyUuid)
      } else {
        Vue.set(this.item, 'parentProperty', this.propertyUuid)
      }
    }
    if (this.level === 1) {
      this.toggleChildren([this.uuid])
    }
    const model = getItemModel(this.item)
    if (model?.className === 'Asset') {
      this.$store.commit('contractStore/addAssetUuid', this.item.uuid)
    }
    this.objectProps.forEach((prop: any) => {
      if (!prop.isCoverage) {
        this.checkPropertyMin(prop)
      }
    })
    this.checkHasItemChild()
    this.isRemovable = this.checkRemovable()
    this.updateName()
    if (this.itemCoverage) {
      if (!this.itemCoverage.premium) {
        this.calculatePremium()
      }
      if (!this.$store.state.contractStore.insurer && this.itemCoverage.insurer) {
        this.$store.state.contractStore.insurer = this.itemCoverage.insurer
      }
    }
  }

  compare() {
    let insurer = null
    for (let uuid of this.$store.state.contractStore.assets) {
      if (uuid !== this.item.uuid) {
        const otherItem = this.$store.state.contractStore.items[uuid]
        if (otherItem) {
          const covUuids = otherItem.properties?.couverture
          if (Array.isArray(covUuids) && covUuids.length > 0) {
            const covItem = this.$store.state.contractStore.items[covUuids[0]]
            if (covItem) {
              const packs = this.$store.state.contractStore.packs || []
              const pack = packs.find((p: any) => p.code?.toUpperCase() === covItem.properties?.pack?.toUpperCase())
              if (pack?.insurer) {
                insurer = pack.insurer
                break
              }
            }
          }
        }
      }
    }
    this.$store.state.contractStore.insurer = insurer
    this.showPackSelector = true
    this.calculatePremium()
  }

  unlockComparison() {
    // this.$emit('update', {type: 'unlockComparison'})
  }

  updateRowHeight() {
    const offers = document.querySelectorAll('.offers')
    offers.forEach((offer: any) => {
      const heads = offer.querySelectorAll('.offers th')

      const rows = offer.querySelectorAll('.offers .results tbody tr')
      const equiRows = offer.querySelectorAll('.offers .guarantee tbody tr')

      let max = 0
      heads.forEach((g: HTMLElement) => {
        g.style.height = 'auto'
        if (g.getBoundingClientRect().height > max) {
          max = g.getBoundingClientRect().height
        }
      })
      heads.forEach((head: HTMLElement) => {
        head.style.height = max + 'px'
      })

      rows.forEach((row: HTMLElement, rowIndex: number) => {
        const equiRow = equiRows[rowIndex]
        const equiCol = equiRow.querySelector('td')

        const columns = row.querySelectorAll('td')
        let max = equiCol.getBoundingClientRect().height;
        columns.forEach((column: HTMLElement) => {
          column.style.height = 'auto'
          if (column.getBoundingClientRect().height > max) {
            max = column.getBoundingClientRect().height
          }
        })
        columns.forEach((column: HTMLElement) => {
          column.style.height = max + 'px'
        })

        // equiCol.forEach((ec: HTMLElement) => {
        equiCol.style.height = max + 'px'
        // })

      })

    })
  }

  openDebug() {
    this.showComparisonDetails = true
    if (this.comparisonResume.length === 0) {
      this.calculatePremium()
    }
  }

  debugDetails(detail) {
    this.functionDetail = detail
  }

  getDuree() {
    // const avenant: Item = this.items.find((i: Item) => {
    //   return i.model().code === 'avenant'
    // }) as any
    // if (avenant instanceof Item) {
    //   const prop = avenant.getPropertyByCode('duree')
    //   const choice = prop.model.choices.find((c: PropertyChoice) => {
    //     return c.code === prop.value
    //   })
    //   return choice ? choice.label : ''
    // }
    return ''
  }

  onePackHasGuarantee(guarantee: Guarantee) {
    for (let coverage of this.coverages) {
      if (this.packHasGuarantee(coverage.pack, guarantee)) {
        return true
      }
    }
    return false
  }

  packHasGuarantee(self: any, guarantee: Guarantee) {
    let match: any = false
    for (let pg of self.packGuarantees) {
      if (pg.guarantee && pg.guarantee.id === guarantee.id) {
        return true
      }
    }
    return false
  }

  isItemRequiredPropertiesFullfit() {
    return true
  }

  // @Watch('pKey', {immediate: true, deep: true})
  async calculatePremium() {
    validateItem(this.item)
    if (!this.item.isValid) return
    const itemModel = getItemModel(this.item)
    if (itemModel?.className !== 'Asset') return
    if (!this.showPackSelector && !this.itemCoverage) return
    if (!engineService.isEngineLoaded) return

    this.currentCoverage = this.itemCoverage
    const method: any = itemModel.method
    if (!method) return

    this.oldCoverages = this.coverages
    this.coverages = []
    this.debugResults = []
    this.comparisonResume = []

    // Construire le payload mapper
    const storeItems = this.$store.state.contractStore.items
    const itemTypes = this.$store.state.contractStore.itemTypes
    const items: any = {}
    const required: string[] = []

    Object.values(storeItems).forEach((si: any) => {
      const m = itemTypes[si.modelCode]
      if (!m) return
      // Extraire les valeurs simples des properties (le worker attend {code: value}, pas {code: {model, value, ...}})
      const flatProps: any = {}
      for (const [code, prop] of Object.entries(si.properties) as any[]) {
        flatProps[code] = prop && typeof prop === 'object' && 'value' in prop ? prop.value : prop
      }
      items[si.uuid] = {modelCode: si.modelCode, name: si.name, properties: flatProps}
      if (m.required) required.push(si.uuid)
    })

    // Les insurers du syncCore sont déjà { id: { ...insurer, packs: [...] } }
    const insurerMap: any = this.$store.state.contractStore.insurers || {}
    const allInsurerValues = Object.values(insurerMap) as any[]

    const insurerIds: string[] = allInsurerValues.filter((i: any) => {
      if (!i.packs || i.packs.length === 0) return false
      if (this.insurerRestriction && i.slug !== this.insurerRestriction && i.uuid !== this.insurerRestriction) return false
      if (!this.showPackSelector && this.$store.state.contractStore.insurer && this.$store.state.contractStore.insurer.slug !== i.slug) return false
      if (!this.showPackSelector && this.itemCoverage && this.itemCoverage.insurer?.slug !== i.slug) return false
      return true
    }).map((i: any) => String(i.id))

    if (insurerIds.length === 0) return

    // Construire l'optionalMap depuis les propriétés de l'item si packCategory est défini
    const itemOptionalMap = {...this.optionalMap}
    const itemPackCategories: string[] = []
    if (this.item.properties.packCategory) {
      itemPackCategories.push(this.item.properties.packCategory)
      // Construire optionalMap pour chaque pack du category sélectionné
      const optGuarantees = this.item.properties.optionalGuarantees || []
      if (optGuarantees.length > 0) {
        const packs = this.$store.state.contractStore.packs || []
        packs.forEach((p: any) => {
          if (p.category?.slug?.toUpperCase() === this.item.properties.packCategory?.toUpperCase()) {
            itemOptionalMap[p.id] = [...optGuarantees]
          }
        })
      }
    }

    const payload: any = {
      required,
      itemUuid: this.item.uuid,
      assetUuids: this.$store.state.contractStore.assets || [],
      method: method.code,
      debug: !!auth.hasRole('ROLE_MANAGER'),
      optionalMap: itemOptionalMap,
      packCategories: itemPackCategories,
    }

    await engineService.setStaticData(itemTypes, insurerMap)
    await engineService.setItems(items)

    try {
      await engineService.calculate(insurerIds, payload, (covResult: any) => {
        const insurer = insurerMap[covResult.insurerId]
        if (!insurer) return
        const pack = insurer.packs?.find((p: any) => p.code?.toUpperCase() === covResult.pack?.toUpperCase())
        if (!pack) return

        // Alimenter comparisonResume pour le debug
        let resumeInsurer = this.comparisonResume.find((i: any) => i.id === insurer.id)
        if (!resumeInsurer) {
          resumeInsurer = {id: insurer.id, uuid: insurer.uuid, label: insurer.label, slug: insurer.slug, active: insurer.active !== false, packs: []}
          this.comparisonResume.push(resumeInsurer)
        }
        resumeInsurer.packs.push({
          id: pack.id,
          uuid: pack.uuid,
          label: pack.label,
          enable: pack.enable !== false,
          premium: covResult.premium,
          details: covResult.details || [],
        })

        const coverage = new Coverage()
        const p = new Pack(pack)
        coverage.generateFromPack(p)
        coverage.insurer = insurer
        coverage.category = pack.category
        coverage.premium = covResult.premium
        coverage.details = covResult.details || []
        coverage.errors = covResult.errors || []
        coverage.canSubscribe = true

        // Assigner les primes et ajouter les optionnelles sélectionnées depuis le worker
        if (covResult.risks) {
          for (const risk of coverage.risks) {
            const workerRisk = covResult.risks[risk.guarantee.id]
            if (workerRisk) {
              risk.premium = workerRisk.premium
            }
          }
          // Ajouter les optionnelles sélectionnées (présentes dans covResult.risks mais pas encore dans coverage.risks)
          for (const [id, wr] of Object.entries(covResult.risks) as any[]) {
            if (wr.isOptional && !coverage.risks.find((r: Risk) => r.guarantee.id === wr.guarantee.id)) {
              const risk = new Risk()
              risk.guarantee = wr.guarantee
              risk.label = wr.label
              risk.premium = wr.premium
              risk.isOptional = true
              risk.maxDescription = wr.maxDescription
              risk.minDescription = wr.minDescription
              coverage.risks.push(risk)
            }
          }
        }

        // Convertir les optionalRisks du worker (objet {id: risk}) en Risk[]
        coverage.optionalRisks = []
        if (covResult.optionalRisks) {
          for (const [id, or] of Object.entries(covResult.optionalRisks) as any[]) {
            const risk = new Risk()
            risk.guarantee = or.guarantee
            risk.label = or.label
            risk.premium = or.premium
            risk.isOptional = true
            risk.maxDescription = or.maxDescription
            risk.minDescription = or.minDescription
            coverage.optionalRisks.push(risk)
          }
        }

        if (covResult.premium > 0) {
          if (!this.showPackSelector && this.itemCoverage && coverage.pack.id === this.itemCoverage.pack?.id) {
            this.selectCoverage(coverage)
            this.$forceUpdate()
            return
          }
          this.coverages.push(coverage)
        } else {
          this.debugResults.push(coverage)
        }
      })
    } catch (e: any) {
      console.error('[calculatePremium] worker error:', e?.message || e)
    }

    if (this.currentCoverage) {
      this.syncCoverageToStore(this.currentCoverage)
    }
    this.oldCoverages = [...this.coverages]
    this.stopCalculation = false
    await this.$store.state.mainStore.sleep(100)
    this.updateRowHeight()
  }


  // isItemContainer() {
  //   let result = false
  //   this.item.properties.forEach((p: Property) => {
  //     if (p.model()!.type.code.match(/OBJECT_GROUP/)) {
  //       result = true
  //     }
  //   })
  //   return result
  // }

  logCoverage() {
    // if (!helper.empty(insurerEngine.errors)) {
    //   insurerEngine.errors.forEach((e: any) => {
    //   })
    // } else {
    //   result.details.forEach((d: any) => {
    //   })
    // }
  }

  parseErrorStack(e: any) {
    if (!e.stack) return []

    return e.stack
        .split('\n')
        .slice(1)
        .map((line: string) => {
          const match =
              line.match(/at\s+(.*?)\s+\((.+):(\d+):(\d+)\)/) ||
              line.match(/at\s+(.+):(\d+):(\d+)/)

          if (!match) return null

          const hasFunction = match.length === 5

          const file = hasFunction ? match[2] : match[1]
          const lineNum = hasFunction ? match[3] : match[2]
          const colNum = hasFunction ? match[4] : match[3]

          return {
            function: hasFunction ? match[1] : '(anonymous)',
            file,
            line: lineNum,
            column: colNum,
            raw: line.trim(),
            sourceUrl: `${file}:${lineNum}:${colNum}`,
          }
        })
        .filter(Boolean)
  }


  // get isContainer() {
  //   let result = true
  //   this.item.properties.forEach((p: Property) => {
  //     if (p.model()) {
  //       if (p.model().type.code !== 'OBJECT_GROUP') {
  //         result = false
  //       }
  //     } else {
  //     }
  //   })
  //   return result
  // }

  // @Watch('optionalReceived', {immediate: true, deep: true})
  updateOptionals() {
    //TODO mettre a jour les optionals
    // this.coverages.forEach((coverage: Coverage) => {
    //   coverage.pack.packGuarantees.forEach((pg: PackGuarantee) => {
    //     // if (pg.isOptional) {
    //     //   const match = this.optionalReceived.find((p: PackGuarantee) => {
    //     //     return p.id === pg.id
    //     //   })
    //     //   if (match) {
    //     //     pg.selected = true
    //     //   } else {
    //     //     pg.selected = false
    //     //   }
    //     // }
    //   })
    // })
    // this.calculatePremium()
  }

  async toggleOptional(coverage: Coverage, guarantee: Guarantee, recalculate = true) {
    const packId = coverage.pack.id
    if (!this.optionalMap[packId]) {
      this.optionalMap[packId] = []
    }
    const idx = this.optionalMap[packId].indexOf(guarantee.id)
    if (idx !== -1) {
      this.optionalMap[packId].splice(idx, 1)
    } else {
      this.optionalMap[packId].push(guarantee.id)
    }
    this.currentCoverage = coverage
    this.$store.state.mainStore.recalculated = []
    if (recalculate) {
      await this.calculatePremium()
    }
  }

  getRequiredCertificates(item: any) {
    let required: any = {
      green: 0,
      blue: 0,
      yellow: 0
    }
    const asaci = getItemModel(item).workflows.find((w: any) => {
      return w.code === 'asaci'
    })
    if (asaci) {
      for (let rule of asaci.rules) {
        let fullfit = true
        for (let condition of rule.conditions) {
          if (condition.property) {
            let prop = getItemPropertyValue(item, condition.property)
            if (prop && condition.operator) {
              switch (condition.operator) {
                case '==': {
                  fullfit = prop == condition.value;
                  break;
                }
                case '!=': {
                  fullfit = prop != condition.value;

                  break;
                }
                case '>': {
                  fullfit = parseFloat(prop) > parseFloat(condition.value);

                  break;
                }
                case '<': {
                  fullfit = parseFloat(prop) < parseFloat(condition.value);
                  break;
                }
              }
            } else {
              fullfit = false
            }
          }
          if (fullfit) {
            if (required.hasOwnProperty(rule.result)) {
              required[rule.result] = 1
              return required
            } else {
            }
          }
        }
      }
    }
  }

  isItemImplementWorkflow(code: string) {
    return getItemModel(this.item).workflows.find((w: any) => {
      return w.code === code
    })
  }

  getRemainingCertificates(insurer: any, item: any) {
    const dataSearch: any = this.searchInItem(item, 'Type')
    let remaining = {
      green: 0,
      blue: 0,
      yellow: 0
    }
    let required = this.getRequiredCertificates(item)

    if (this.certificateRemaining) {
      for (let data of this.certificateRemaining) {
        if (insurer.uuid === data.uuid) {
          if (required.yellow > 0) {
            remaining.yellow = data.eAttestationCountYellow;
          } else if (required.green > 0) {
            remaining.green = data.eAttestationCountGreen
          } else if (required.blue > 0) {
            remaining.blue = data.eAttestationCountBlue
          }
          return remaining
        }
      }
    }

    return remaining
  }

  searchInItem(item: Item, searchName: string): string | undefined {
    if (item.name === searchName) {
      return '';
    }

    for (const property of Object.values(item.properties || {}) as any[]) {
      if (property.name === searchName) {
        return property.value;
      }

      if (property.children) {
        for (const child of property.children) {
          const result = this.searchInItem(child, searchName);
          if (result) return result;
        }
      }
    }


    // Si rien n'est trouvé, retourner undefined
    return undefined;
  }

  getPackPremium(coverage: Coverage) {
    let premium = coverage.premium
    // result.pack.packGuarantees.forEach((pg: PackGuarantee) => {
    //     const optional = this.getOptionalPremium(result, pg.guarantee)
    //     if (pg.selected && optional) {
    //         premium += optional.premium
    //     }
    // })
    return premium
  }

  selectCoverage(coverage?: Coverage) {
    this.stopCalculation = true
    if (coverage) {
      if (this.$store.state.contractStore.insurer) {
        if (coverage.insurer.uuid !== this.$store.state.contractStore.insurer.uuid) {
          new Popup('Erreur', 'Ce contrat contient déjà des offres ' + this.$store.state.contractStore.insurer.label)
          return
        }
      }
      this.$store.state.contractStore.insurer = coverage.insurer
    }
    const currentPack = this.currentCoverage?.pack?.id || this.currentCoverage?.pack?.code
    const newPack = coverage?.pack?.id || coverage?.pack?.code
    if (!this.currentCoverage || currentPack !== newPack) {
      this.$emit('itemUpdated', [this.item.uuid])
    }
    this.currentCoverage = coverage
    if (coverage) {
      this.syncCoverageToStore(coverage)
    } else {
      Vue.set(this.item.properties, 'couverture', [])
    }
    this.showPackSelector = false
  }

  canSubscribe(result: any) {
    if (this.isItemImplementWorkflow('asaci')) {
      const requirements = this.getRequiredCertificates(this.item)
      if (result && result.pack && result.pack.code && result.pack.code.toLowerCase().includes('test') && auth.hasRole('ROLE_MANAGER')) {
        return true
      }
      for (let data of store.state.comparatorStore.autoCertificates) {
        if (result.pack.insurer.uuid === data.uuid) {
          if (requirements.blue > 0) {
            if (requirements.blue > data.eAttestationCountBlue) {
              new Popup("Rupture de Stock", "Nous manquons d'attestation bleue " + result.pack.insurer.label)
              return false
            }
          }
          if (requirements.yellow > 0) {
            if (requirements.yellow > data.eAttestationCountYellow) {
              new Popup("Rupture de Stock", "Nous manquons d'attestation jaune " + result.pack.insurer.label)
              return false
            }
          }
          if (requirements.green > 0) {
            if (requirements.green > data.eAttestationCountGreen) {
              new Popup("Rupture de Stock", "Nous manquons d'attestation verte " + result.pack.insurer.label)
              return false
            }
          }
          return true
        }
      }
      return false
    }
    return true
  }

  getSubItemList(item: any, uuids: string[] = [], labels: string[] = []) {
    uuids.push(item.uuid)
    if (labels.length < 3) {
      labels.push(getIdentifier(item) || item.name || item.uuid)
    } else if (labels[labels.length - 1] !== '...') {
      labels.push('...')
    }
    const model = getItemModel(item)
    if (!model?.properties) return {uuids, labels}
    const itemTypes = this.$store.state.contractStore.itemTypes
    Object.values(model.properties).forEach((pm: any) => {
      const isObject = pm.type?.format === 'OBJECT' || pm.type?.format === 'OBJECT_GROUP' || pm.type?.code?.match(/OBJECT/)
      if (!isObject) return
      const subItemType: any = Object.values(itemTypes).find((it: any) => it.uuid === pm.value)
      if (subItemType?.code === 'coverage') return
      const value = item.properties?.[pm.code]
      const children = Array.isArray(value) ? value : (value ? [value] : [])
      children.forEach((childUuid: string) => {
        const subitem = this.$store.getters["contractStore/getEntity"]('items', childUuid)
        if (subitem) {
          this.getSubItemList(subitem, uuids, labels)
        }
      })
    })
    return {uuids, labels}
  }

  async removeItem(item: any, bypass = false) {
    const {uuids, labels} = this.getSubItemList(item)
    let response = {
      isConfirmed: true
    }
    if (!bypass) {
      response = await Swal.fire({
        title: 'Supprimer',
        html: 'Êtes-vous sûr de vouloir supprimer les objets ' + labels.join(', ') + ' ?',
        showCancelButton: true,
        confirmButtonText: 'Supprimer',
        cancelButtonText: 'Annuler',
      })
    }
    if (response.isConfirmed) {
      this.$emit('removeItem', this.item.uuid)
      // Nettoyer les assets du store
      uuids.forEach((uuid: string) => {
        store.commit('contractStore/removeAssetUuid', uuid)
      })
      store.commit('contractStore/removeEntities', {target: 'items', uuids: uuids})
    }
  }

  removeChild(uuid: string) {
    const model = getItemModel(this.item)
    if (!model?.properties) return
    let removed = false
    Object.values(model.properties).forEach((pm: any) => {
      const isObject = pm.type?.format === 'OBJECT' || pm.type?.format === 'OBJECT_GROUP' || pm.type?.code?.match(/OBJECT/)
      if (!isObject) return
      const value = this.item.properties?.[pm.code]
      if (Array.isArray(value) && value.includes(uuid)) {
        Vue.set(this.item.properties, pm.code, value.filter((child: string) => child !== uuid))
        removed = true
      }
    })
    if (!removed) {
      Object.entries(this.item.properties || {}).forEach(([code, value]: [string, any]) => {
        if (Array.isArray(value) && value.includes(uuid)) {
          Vue.set(this.item.properties, code, value.filter((child: string) => child !== uuid))
          removed = true
        }
      })
    }
    // Nettoyer aussi la liste d'assets du store si c'est un asset
    store.commit('contractStore/removeAssetUuid', uuid)
    this.checkHasItemChild()
    this.update([this.item.uuid])
    // Redessiner les connecteurs SVG (paths) après suppression
    this.$emit('link')
  }

  appendItem(occ: Item) {
    this.$emit('appendItem', occ)
  }

}


</script>
<style scoped>
.results {
  /*border-collapse: separate;*/
}

.scroller {
  min-width: 0 !important;
}

.delete-button {
  display: none;
}

.item-tree-container:hover .delete-button {
  display: flex;
}

.filter {
  position: relative;
  /*top: 0;*/
  /*left: 0;*/
  width: 100%;
  height: 100%;
  /* background: rgba(255, 255, 255, .75); */
  /*z-index: 9999;*/
  display: flex;
  justify-content: center;
  align-items: center;

  background-size: 4px 4px;
  background-image: radial-gradient(transparent 1px, rgba(255, 255, 255, .5) 1px);
  backdrop-filter: saturate(50%) blur(4px);
  /*backdrop-filter: blur(2px);*/
}

.draggable-item {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-width: 100px;
  aspect-ratio: 1/1;
  z-index: 1;
  background: white;
  perspective: 800px;
}

.draggable-item:hover .white-box {
  border-color: var(--bs-blue)
}

.draggable-item.group .white-box {
  width: 100%;
  height: 100%;
  position: relative;
  flex: 1;
  transition: all .5s ease;
}

.draggable-item.group .before {
  position: absolute;
  content: '';
  width: 80%;
  height: 80%;
  border: 1px gray dashed;
  background: whitesmoke;
  display: flex;
  align-items: center;
  justify-content: center;
  left: -35%;
  top: 10%;
  border-radius: 5px;
  z-index: -1;
  transform: rotateY(35deg);
  transition: all .5s ease;
}

.draggable-item.group .after {
  position: absolute;
  content: '';
  width: 80%;
  height: 80%;
  border: 1px gray dashed;
  display: flex;
  align-items: center;
  justify-content: center;
  background: whitesmoke;
  right: -35%;
  top: 10%;
  border-radius: 5px;
  z-index: -1;
  transform: rotateY(-35deg);
  transition: all .5s ease .1s;
}

.draggable-item.group:hover .before {
  left: -70%;
  transform: rotateY(35deg);
  background: #ECF8FF;
  border: 1px dashed var(--bs-blue);
}

.draggable-item.group:hover .after {
  right: -70%;
  transform: rotateY(-35deg);
  background: #ECF8FF;
  border: 1px dashed var(--bs-blue);

}

.item-tree-container > .menu {
  opacity: 0;
  display: flex;
  transition: all .5s ease;
  transform: translateX(10px);
}

.item-tree-container:hover > .menu {
  opacity: 1;
  transform: translateX(0);
}

.offers tbody tr:nth-child(2n+1) {
  background: #a0d8ff26;
}


.accordion {
  max-height: 0;
  overflow: hidden;
}

.checkbox-accordion {
  display: none;
}

.checkbox-accordion:checked ~ .accordion {
  max-height: none;
}

.checkbox-accordion:checked ~ label .fa-caret-right {
  display: none;
}

.checkbox-accordion:not(:checked) ~ label .fa-caret-down {
  display: none;
}


.results td,
.results th {
  min-width: 200px;
}

.results-container {
  position: relative;
  /*border: 1px red solid;*/
}

.results-container:before,
.results-container:after {
  content: '';
  width: 50px;
  height: 100%;
  position: absolute;
  pointer-events: none;
  left: 0;
  top: 0;
  /*background: rgb(2,0,36);*/
  background: linear-gradient(-90deg, rgba(2, 0, 36, 0) 0%, rgba(255, 255, 255, 1) 75%);

}

.results-container:after {
  left: auto;
  right: 0;
  background: linear-gradient(90deg, rgba(2, 0, 36, 0) 0%, rgba(255, 255, 255, 1) 75%);
}

.results td {
  border-right: 20px white solid;
  /*background: rgba(255, 255, 255, 0.21);*/
}


</style>
